import { cloneDeep } from 'lodash';

import {
  ACCOUNT_BSB_QUESTIONS,
  APPLICANT_QUESTIONS,
  APPLICATION_QUESTIONS,
  ASSET_QUESTIONS,
  COMPANY_DECLARATION_QUESTIONS,
  COMPANY_QUESTIONS,
  COMPLIANCE_QUESTIONS,
  ENTITY_TYPE,
  GUARANTOR_COMPLIANCE_QUESTIONS,
  LIABILITY_QUESTIONS,
  LICENSED_BUILDER_QUESTIONS,
  RELATED_PARTY_QUESTIONS,
  TRUST_BENEFICIARY_QUESTIONS,
  TRUST_SETTLOR_QUESTIONS,
} from '@funnels/constants';
import { PostProductSelectContract } from '@funnels/types';

export const PPS_COMPLIANCE_MOCK_ENTITY = {
  entityType: ENTITY_TYPE.COMPLIANCE,
  questions: [
    COMPLIANCE_QUESTIONS.AGREEMENT_OF_UNDERSTANDING,
    COMPLIANCE_QUESTIONS.CUSTOMER_DISCUSSION_SUMMARY,
    COMPLIANCE_QUESTIONS.INTERVIEWED_IN_PERSON,
    COMPLIANCE_QUESTIONS.INTERVIEW_LOCATION,
    COMPLIANCE_QUESTIONS.REQUIREMENTS_AND_OBJECTIVES_SUMMARY,
    COMPLIANCE_QUESTIONS.UNDERSTAND_ENGLISH,
  ],
};

export const PPS_GUARANTOR_COMPLIANCE_MOCK_ENTITY = {
  entityId: 'applicant-1',
  entityType: ENTITY_TYPE.GUARANTOR_COMPLIANCE,
  questions: [
    GUARANTOR_COMPLIANCE_QUESTIONS.BROKER_DECLARATION,
    GUARANTOR_COMPLIANCE_QUESTIONS.CONFIRM_COULD_MEET_LOAN_REPAYMENTS,
    GUARANTOR_COMPLIANCE_QUESTIONS.CONFIRM_WOULD_SELL_FAMILY_HOME,
    GUARANTOR_COMPLIANCE_QUESTIONS.DOCUMENTATION_DELIVERY_METHOD,
    GUARANTOR_COMPLIANCE_QUESTIONS.INDEPENDENT_ADVICE_TYPE_REQUIRED,
    GUARANTOR_COMPLIANCE_QUESTIONS.INTERVIEWED_IN_PERSON,
    GUARANTOR_COMPLIANCE_QUESTIONS.INTERVIEW_LOCATION,
    GUARANTOR_COMPLIANCE_QUESTIONS.IS_ONLY_PERSON_PRESENT,
    GUARANTOR_COMPLIANCE_QUESTIONS.IS_UNDER_POWER_OF_ATTORNEY,
    GUARANTOR_COMPLIANCE_QUESTIONS.LENDER_SPECIFIC_BROKER_DECLARATION,
    GUARANTOR_COMPLIANCE_QUESTIONS.UNDERSTANDS_ENGLISH,
    GUARANTOR_COMPLIANCE_QUESTIONS.UNDERSTANDS_GUARANTEE_SIGNING_PERIOD,
    GUARANTOR_COMPLIANCE_QUESTIONS.UNDERSTANDS_SECURITY_GUARANTEE,
    GUARANTOR_COMPLIANCE_QUESTIONS.INTERVIEW_DATE,
  ],
};

export const PPS_ASSET_ACCOUNT_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'asset-11',
    entityType: ENTITY_TYPE.ASSET_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
  {
    entityId: 'asset-2',
    entityType: ENTITY_TYPE.ASSET_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
  {
    entityId: 'asset-16',
    entityType: ENTITY_TYPE.ASSET_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
];

export const PPS_ACCOUNTANT_ENTITY = {
  entityId: 'employment-1',
  entityType: ENTITY_TYPE.ACCOUNTANT,
  questions: [
    RELATED_PARTY_QUESTIONS.TITLE,
    RELATED_PARTY_QUESTIONS.FIRST_NAME,
    RELATED_PARTY_QUESTIONS.LAST_NAME,
    RELATED_PARTY_QUESTIONS.PHONE,
    RELATED_PARTY_QUESTIONS.BUSINESS_NAME,
    RELATED_PARTY_QUESTIONS.ADDRESS,
  ],
};

export const PPS_COMPANY_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'applicant-11',
    entityType: ENTITY_TYPE.COMPANY,
    questions: [
      COMPANY_QUESTIONS.LEGAL_ENTITIES_IN_GROUP,
      COMPANY_QUESTIONS.BRANCH,
      COMPANY_QUESTIONS.LEGAL_ENTITIES_IN_GROUP,
    ],
  },
];
export const PPS_COMPANY_DECLARATION_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'applicant-11',
    entityType: ENTITY_TYPE.COMPANY_DECLARATION,
    questions: [
      COMPANY_DECLARATION_QUESTIONS.HAS_GOOD_CONDUCT,
      COMPANY_DECLARATION_QUESTIONS.WAS_BANKRUPT_OR_INSOLVENT,
      COMPANY_DECLARATION_QUESTIONS.HAD_LATE_PAYMENTS_OR_ARREARS_OR_ADVERSE_CREDIT_HISTORY,
    ],
  },
];

export const PPS_LIABILITY_ACCOUNT_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'liability-1',
    entityType: ENTITY_TYPE.LIABILITY_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
  {
    entityId: 'liability-2',
    entityType: ENTITY_TYPE.LIABILITY_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
];

export const PPS_LIABILITY_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'liability-1',
    entityType: ENTITY_TYPE.LIABILITY,
    questions: [LIABILITY_QUESTIONS.ANNUAL_INTEREST_RATE],
  },
];

export const PPS_RATE_LOCK_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'application-1',
    entityType: ENTITY_TYPE.APPLICATION,
    questions: [APPLICATION_QUESTIONS.RATE_LOCK],
  },
];

export const PPS_FAST_REFI_ENTITY: PostProductSelectContract[] = [
  {
    entityId: 'application-1',
    entityType: ENTITY_TYPE.APPLICATION,
    questions: [APPLICATION_QUESTIONS.FAST_REFI],
  },
];

export const PPS_TRUST_SETTLOR: PostProductSelectContract = {
  entityId: 'applicant-1',
  entityType: ENTITY_TYPE.TRUST_SETTLOR,
  questions: [...Object.values(TRUST_SETTLOR_QUESTIONS)],
};

export const PPS_TRUST_BENEFICIARY: PostProductSelectContract = {
  entityId: 'applicant-1',
  entityType: ENTITY_TYPE.TRUST_BENEFICIARY,
  questions: [TRUST_BENEFICIARY_QUESTIONS.DISTRIBUTION_PERCENTAGE],
};

export const POST_PRODUCT_MOCK_QUESTIONS: PostProductSelectContract[] = [
  {
    entityId: 'applicant-1',
    entityType: ENTITY_TYPE.APPLICANT,
    questions: [
      APPLICANT_QUESTIONS.COUNTRY_OF_BIRTH,
      APPLICANT_QUESTIONS.CITY_OF_BIRTH,
      APPLICANT_QUESTIONS.MOTHERS_MAIDEN_NAME,
      APPLICANT_QUESTIONS.COUNTRY_OF_CITIZENSHIP,
      APPLICANT_QUESTIONS.SPOUSE_FIRST_NAME,
      APPLICANT_QUESTIONS.SPOUSE_LAST_NAME,
      APPLICANT_QUESTIONS.SPOUSE_TITLE,
    ],
  },
  {
    entityId: 'applicant-2',
    entityType: ENTITY_TYPE.APPLICANT,
    questions: [APPLICANT_QUESTIONS.COUNTRY_OF_BIRTH, APPLICANT_QUESTIONS.MOTHERS_MAIDEN_NAME],
  },
  {
    entityId: 'asset-1',
    entityType: ENTITY_TYPE.ASSET,
    questions: [
      ASSET_QUESTIONS.CONTACT_COMPANY_NAME,
      ASSET_QUESTIONS.CONTACT_FIRST_NAME,
      ASSET_QUESTIONS.CONTACT_LAST_NAME,
      ASSET_QUESTIONS.CONTACT_PHONE,
      ASSET_QUESTIONS.CONTACT_TITLE,
      ASSET_QUESTIONS.CONTACT_TYPE,
      ASSET_QUESTIONS.DATE_OF_PURCHASE,
    ],
  },
  {
    entityId: 'asset-2',
    entityType: ENTITY_TYPE.ASSET,
    questions: [
      ASSET_QUESTIONS.CONTACT_COMPANY_NAME,
      ASSET_QUESTIONS.CONTACT_FIRST_NAME,
      ASSET_QUESTIONS.CONTACT_LAST_NAME,
      ASSET_QUESTIONS.CONTACT_TITLE,
      ASSET_QUESTIONS.CONTACT_TYPE,
      ASSET_QUESTIONS.DATE_OF_PURCHASE,
    ],
  },
  {
    entityId: 'relatedParty-1',
    entityType: ENTITY_TYPE.ACCOUNTANT,
    questions: [
      RELATED_PARTY_QUESTIONS.TITLE,
      RELATED_PARTY_QUESTIONS.FIRST_NAME,
      RELATED_PARTY_QUESTIONS.LAST_NAME,
      RELATED_PARTY_QUESTIONS.PHONE,
      RELATED_PARTY_QUESTIONS.BUSINESS_NAME,
      RELATED_PARTY_QUESTIONS.ADDRESS,
    ],
  },
  {
    entityId: 'relatedParty-2',
    entityType: ENTITY_TYPE.SOLICITOR,
    questions: [
      RELATED_PARTY_QUESTIONS.TITLE,
      RELATED_PARTY_QUESTIONS.FIRST_NAME,
      RELATED_PARTY_QUESTIONS.LAST_NAME,
      RELATED_PARTY_QUESTIONS.PHONE,
      RELATED_PARTY_QUESTIONS.EMAIL,
      RELATED_PARTY_QUESTIONS.BUSINESS_NAME,
      RELATED_PARTY_QUESTIONS.ADDRESS,
    ],
  },
  PPS_COMPLIANCE_MOCK_ENTITY,
  {
    entityId: 'relatedParty-3',
    entityType: ENTITY_TYPE.ACCOUNTANT,
    questions: [
      RELATED_PARTY_QUESTIONS.TITLE,
      RELATED_PARTY_QUESTIONS.FIRST_NAME,
      RELATED_PARTY_QUESTIONS.LAST_NAME,
      RELATED_PARTY_QUESTIONS.PHONE,
      RELATED_PARTY_QUESTIONS.BUSINESS_NAME,
      RELATED_PARTY_QUESTIONS.ADDRESS,
    ],
  },
  {
    entityId: 'asset-4',
    entityType: ENTITY_TYPE.LICENSED_BUILDER,
    questions: [
      RELATED_PARTY_QUESTIONS.TITLE,
      RELATED_PARTY_QUESTIONS.FIRST_NAME,
      RELATED_PARTY_QUESTIONS.LAST_NAME,
      RELATED_PARTY_QUESTIONS.PHONE,
      RELATED_PARTY_QUESTIONS.BUSINESS_NAME,
      RELATED_PARTY_QUESTIONS.ADDRESS,
      LICENSED_BUILDER_QUESTIONS.LICENSED_BUILDER_LANDLINE,
      LICENSED_BUILDER_QUESTIONS.LICENSE_NUMBER,
    ],
  },
  {
    entityId: 'liability-7',
    entityType: ENTITY_TYPE.LIABILITY_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
  {
    entityId: 'liability-3',
    entityType: ENTITY_TYPE.LIABILITY_ACCOUNT,
    questions: [ACCOUNT_BSB_QUESTIONS.ACCOUNT_BSB, ACCOUNT_BSB_QUESTIONS.ACCOUNT_NUMBER],
  },
  ...PPS_ASSET_ACCOUNT_ENTITY,
  ...PPS_COMPANY_ENTITY,
  ...PPS_COMPANY_DECLARATION_ENTITY,
];

export const getMockPostProductSelectContract = (): PostProductSelectContract[] =>
  cloneDeep(POST_PRODUCT_MOCK_QUESTIONS);
